var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.521 7A5.688 5.688 0 1 0 2.146 7a5.688 5.688 0 0 0 11.375 0M.833 7a7 7 0 1 1 14 0 7 7 0 0 1-14 0M8.49 3.281V7a.655.655 0 0 1-.657.656H4.99A.655.655 0 0 1 4.333 7c0-.364.293-.656.657-.656h2.187V3.28c0-.363.293-.656.657-.656.363 0 .656.293.656.656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.833 0h14v14h-14z"
  })))));
};
export default SvgClock;